class JsRecommendationCarousel extends HTMLDivElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-recommendation-slide]'));
    this.index = Math.max(
      0,
      this.slides.findIndex((slide) => slide.classList.contains('is-active') || !slide.hidden)
    );
    if (this.index < 0) this.index = 0;

    this.prevButtons = this.querySelectorAll('[data-recommendation-prev]');
    this.nextButtons = this.querySelectorAll('[data-recommendation-next]');
    this.counters = this.querySelectorAll('[data-recommendation-count]');
    this.nav = this.querySelector('.js-product-info__quote-nav');

    this.prevButtons.forEach((button) => button.addEventListener('click', () => this.go(-1)));
    this.nextButtons.forEach((button) => button.addEventListener('click', () => this.go(1)));

    if (this.nav) {
      this.nav.hidden = this.slides.length < 2;
    }

    this.update();
  }

  go(direction) {
    if (this.slides.length < 2) return;
    this.index = (this.index + direction + this.slides.length) % this.slides.length;
    this.update();
  }

  update() {
    this.slides.forEach((slide, index) => {
      slide.classList.toggle('is-active', index === this.index);
      slide.toggleAttribute('hidden', index !== this.index);
    });
    this.counters.forEach((counter) => {
      counter.textContent = `${this.index + 1}/${this.slides.length}`;
    });
  }
}

if (!window.customElements.get('js-recommendation-carousel')) {
  window.customElements.define('js-recommendation-carousel', JsRecommendationCarousel, { extends: 'div' });
}

class JsAlsoLikeRecommendations extends HTMLElement {
  connectedCallback() {
    this.load();
  }

  async load() {
    if (this.dataset.loaded === 'true') return;
    this.dataset.loaded = 'true';

    if (this.querySelector('.js-cart-drawer__upsell-card')) return;

    const section = this.closest('.shopify-section');
    if (!section || !this.getAttribute('product')) {
      this.hidden = true;
      return;
    }

    const sectionId = section.id.replace('shopify-section-', '');
    const limit = this.getAttribute('limit') || '5';
    const url = `${Shopify.routes.root}recommendations/products?product_id=${this.getAttribute('product')}&limit=${limit}&section_id=${sectionId}&intent=related`;

    try {
      const response = await fetch(url, { priority: 'low' });
      const tempDiv = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = tempDiv.querySelector('js-also-like-recommendations');

      if (next && next.querySelector('.js-cart-drawer__upsell-card')) {
        this.replaceChildren(...document.importNode(next, true).childNodes);
      } else {
        this.hidden = true;
      }
    } catch (error) {
      this.hidden = true;
    }
  }
}


if (!window.customElements.get('js-also-like-recommendations')) {
  window.customElements.define('js-also-like-recommendations', JsAlsoLikeRecommendations);
}
